import { render, staticRenderFns } from "./EmbedTable.vue?vue&type=template&id=8f7c43c0&scoped=true"
import script from "./EmbedTable.vue?vue&type=script&lang=js"
export * from "./EmbedTable.vue?vue&type=script&lang=js"
import style0 from "./EmbedTable.vue?vue&type=style&index=0&id=8f7c43c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7c43c0",
  null
  
)

export default component.exports